module.exports = __webpack_public_path__ + "img/prototype_tic-tac-toe.5d6db483.gif";